// API Endpoints Configuration
export const API_END_POINTS = {
  AUTH: {
    SEND_OTP: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/send-otp`,
    LOGIN: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/login`,
    FORGOT_PASSWORD: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/forgot-password`,
    RESET_PASSWORD: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/reset-password`,
    CHANGE_PASSWORD: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/change-password`,
    LOGOUT: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/logout`,
    PROFILE: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/profile`,
  },
  CATEGORY: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/category`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/category/list`,
  },
  SERVICE: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/service`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/service/list`,
  },
  DEPARTMENT: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/department`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/department/list`,
  },
  COMPLAIN: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/complain`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/complain/list`,
  },
  PROVIDER: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/provider`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/provider/list`,
  },
  TICKET: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/ticket`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/ticket/list`,
    ADD: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/ticket/create`,
    VIEW: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/ticket/details`,
    ISSUES: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/ticket/issues`,
    PREVIOUS_TICKETS: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/ticket/customer/{id}/previous-tickets`,
    ORDER_DETAIL: `${process.env.REACT_APP_FOOD_SERVICE_NAME}admin/orders/detail`,
  },
  TICKET_CHAT: {
    CONVERSATIONS: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/conversations`,
    MESSAGES: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/ticket/{id}/messages`,
    CHAT_LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/ticket/{id}/list`,
    SEND_MESSAGE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/send`,
    READ_ALL: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/ticket/{id}/read-all`,
    EDIT_MESSAGE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/message/{id}`,
    DELETE_MESSAGE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/chat/message/{id}`,
  },
  USER: {
    PROFILE_BY_PHONE_NUMBER: `${process.env.REACT_APP_USERS_SERVICE_NAME}users/user-profile-by-phone-number`,
  },
  DASHBOARD: {
    HORIZONTAL_BAR_CHART: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/dashboard/horizontal-bar-chart`,
    VERTICAL_BAR_CHART: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/dashboard/vertical-bar-chart`,
    SERVICE_SUMMARY: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/dashboard/service-summary`,
    PIE_CHART: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/dashboard/pie-chart`,
    TICKET_STATUS_SUMMARY: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/dashboard/ticket-status-summary`,
  },
  ROLES: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/roles`,
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/roles/list`,
    ME: `${process.env.REACT_APP_CRM_SERVICE_NAME}/crm/role/me`,
    MODULES: `${process.env.REACT_APP_CRM_SERVICE_NAME}/crm/role/modules/lookup`,
    //STATUS: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/roles/${id}status}/`,
  },
  USER_ROLES: {
    LIST: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/user-roles`,
    ASSIGN: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/user-roles/assign`,
    STATUS: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/user-roles/status/`,
    UNASSIGN: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/user-roles/unassign`,
    DETAILS: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/user-roles/details`,
    UPDATE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/user-roles/update`,
    SUB_CRM_USERS: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/role/admins/sub-crm-users`,
  },
  SUB_CRM_USERS: {
    LIST: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/sub-crm-users`,
  },
  //@TODO CHNAGE IN ROLE
  // SUB_CRM_USERS: {
  //   LIST: `${process.env.REACT_APP_USERS_SERVICE_NAME}admins/sub-crm-users`,
  // },
  COMMON: {
    UPLOAD_FILE: `${process.env.REACT_APP_COMMON_SERVICE_NAME}services/upload-file`,
    SEND_PUSH_BY_ID: `${process.env.REACT_APP_COMMON_SERVICE_NAME}services/send-push-by-id`,
  },
  SERVICE_ORDERS: {
    FOOD: { name: 'Food', env: 'FOOD_SERVICE_URL', path: `${process.env.REACT_APP_FOOD_SERVICE_NAME}admin/orders/recent`, method: 'GET' },
    ESIM: { name: 'eSIM', env: 'DIGITAL_SERVICES_URL', path: `${process.env.REACT_APP_DIGITAL_SERVICE_SERVICE_NAME}admin/orders/recent`, method: 'GET' },
    HOTEL: { name: 'Hotel', env: 'HOTEL_SERVICE_URL', path: `${process.env.REACT_APP_HOTELS_SERVICE_NAME}hotels/crm/admin/orders`, method: 'GET' },
    GROCERY: { name: 'Grocery', env: 'GROCERY_SERVICE_URL', path: `${process.env.REACT_APP_GROCERY_SERVICE_NAME}order/admin-order/recent`, method: 'GET' },
    GIFTCARD: { name: 'GiftCards', env: 'DIGITAL_SERVICES_URL', path: `${process.env.REACT_APP_DIGITAL_SERVICE_SERVICE_NAME}admin/orders/recent`, method: 'GET' },
    TOPUP: { name: 'Topup', env: 'DIGITAL_SERVICES_URL', path: `${process.env.REACT_APP_DIGITAL_SERVICE_SERVICE_NAME}admin/orders/recent`, method: 'GET' },
    EVOUCHER: { name: 'eVoucher', env: 'DIGITAL_SERVICES_URL', path: `${process.env.REACT_APP_DIGITAL_SERVICE_SERVICE_NAME}admin/orders/recent`, method: 'GET' },
    VISA: { name: 'Visa CRM Orders', env: 'VISA_SERVICE_URL', path: `${process.env.REACT_APP_VISA_SERVICE_NAME}admin/visa/crm-orders`, method: 'POST' },
    ECOM: { name: 'Ecommerce', env: 'ECOM_SERVICE_URL', path: `${process.env.REACT_APP_ECOM_SERVICE_NAME}admin/orders/recent`, method: 'GET' },
    // GIFTING: { name: 'GiftCards', env: 'GIFT_SERVICE_URL', path: `${process.env.REACT_APP_GIFT_SERVICE_NAME}gifts/admin/orders/recent`, method: 'POST' },
    // Mini-app tickets don't fit the SERVICE_ORDERS one-shot shape
    // (needs a mini-app picker between service + orders). Kept out of
    // SERVICE_CONFIG on purpose — the ticket form branches on
    // service_type_code === 'MA' and uses MINI_APP_CORE below directly.
    GIFTING: { name: 'Gifting', env: 'GIFTING_SERVICE_URL', path: `${process.env.REACT_APP_GIFTING_SERVICE_NAME}gifts/admin/crm/orders/{id}`, method: 'GET' },
    INSURANCE: { name: 'Insurance', env: 'INSURANCE_SERVICE_URL', path: `${process.env.REACT_APP_INSURANCE_SERVICE_NAME}admin/crm/orders/{id}`, method: 'GET' },
  },
  MINI_APP_CORE: {
    // Path-only URLs (no scheme/host). Axios prepends the browser
    // origin at request time, which routes the call through the CRM
    // proxy at <crm-host>/mini-app-core/* — that's the same-origin
    // path that gets the session cookie translated into upstream auth,
    // mirroring how /food/*, /grocery/* etc. work.
    //
    // The env var is intentionally NOT used for the host portion:
    // if it were set to a full URL, the resolved path would be
    // absolute and axios would bypass the browser origin, breaking
    // cookie flow (mini-app-core would 401 on adminAuth).
    MINI_APPS_FOR_USER: `${process.env.REACT_APP_MINI_APP_CORE_SERVICE_NAME || '/mini-app-core/'}admin/v1/orders/mini-apps-for-user`.replace(/\/+/g, '/'),
    ORDERS: `${process.env.REACT_APP_MINI_APP_CORE_SERVICE_NAME || '/mini-app-core/'}admin/v1/orders`.replace(/\/+/g, '/'),
  },
  ACTIVITY_LOG: {
    BASE: `${process.env.REACT_APP_CRM_SERVICE_NAME}crm/activity-logs`,
  },
  CUSTOMER: {
    LIST: `${process.env.REACT_APP_SG_ADMIN_SERVICE_NAME}api/crm/customers`,
    DETAIL: `${process.env.REACT_APP_SG_ADMIN_SERVICE_NAME}api/crm/customers/crm-details/`,
  },
  CONTACT_US: {
    LIST: `${process.env.REACT_APP_SG_ADMIN_SERVICE_NAME}api/crm/contact-us-list`,
  },
  ORDER_RETURN: {
    LIST: `${process.env.REACT_APP_SG_ADMIN_SERVICE_NAME}api/crm/ecom-return-orders`,
    DETAIL: `${process.env.REACT_APP_SG_ADMIN_SERVICE_NAME}api/crm/ecom-return-orders/detail`,
    PROCESS_REFUND: `${process.env.REACT_APP_ECOM_SERVICE_NAME}admin/return-requests/process-refund`,
  },
};
